import React from 'react'
import ContentHeader from '@Components/ContentHeader'
import ButtonCreateNewWork from '@Components/Buttons/ButtonCreateNewWork'
import PermissionCheck from '@App/kit/components/Utility/PermissionCheck'
import { PERMISSIONS } from '@Const/permissions'

const CatalogHeader = () => (
    <ContentHeader title="Catalog">
        <PermissionCheck requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.manage_works]}>
            <ButtonCreateNewWork />
        </PermissionCheck>
    </ContentHeader>
)
export default CatalogHeader
